import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

export interface UsageBucket {
  start: string;
  credits: number;
  requests: number;
}

export interface UsageKey {
  id: string;
  name: string | null;
  secretPrefix: string | null;
  createdAt: string | null;
  revokedAt: string | null;
  usage: UsageBucket[];
}

export interface CreditBalance {
  periodStart: string;
  periodEnd: string;
  allowance: number;
  spent: number;
  available: number;
}

export interface UsageData {
  balance: CreditBalance;
  apiKeys: UsageKey[];
}

/** This month's balance, and every key's hourly usage over UTC days [from, to]. */
export const USAGE: TypedDocumentNode<UsageData, { from: string; to: string }> = gql`
  query Usage($from: Date!, $to: Date!) {
    balance {
      periodStart
      periodEnd
      allowance
      spent
      available
    }
    apiKeys(includeRevoked: true) {
      id
      name
      secretPrefix
      createdAt
      revokedAt
      usage(from: $from, to: $to, granularity: HOUR) {
        start
        credits
        requests
      }
    }
  }
`;
